(function () {
  const root = document.querySelector('[data-ibscent-vids]');
  if (!root) return;

  const grid = root.querySelector('[data-vids-grid]');
  const items = Array.prototype.slice.call(root.querySelectorAll('[data-vid-item]'));
  const show = parseInt(root.getAttribute('data-vids-show'), 10) || 4;
  const modal = root.querySelector('[data-vid-modal]');
  const player = root.querySelector('[data-vid-player]');
  const modalTitle = root.querySelector('[data-vid-modal-title]');

  const shuffled = items.slice();
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = shuffled[i]; shuffled[i] = shuffled[j]; shuffled[j] = t;
  }
  const visible = shuffled.slice(0, show);
  visible.forEach((el) => { el.hidden = false; grid.appendChild(el); });

  if (visible.length === 0) { root.hidden = true; return; }

  let lastFocus = null;

  function openModal(src, title) {
    lastFocus = document.activeElement;
    player.innerHTML = '';
    const video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.className = 'ibscent-pdp-vids__video';
    player.appendChild(video);
    modalTitle.textContent = title || '';
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('[data-vid-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    player.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.querySelectorAll('[data-vid-open]').forEach((btn) => {
    btn.addEventListener('click', () => {
      openModal(btn.getAttribute('data-vid-src'), btn.getAttribute('data-vid-title'));
    });
  });

  modal.querySelectorAll('[data-vid-close]').forEach((c) => c.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') closeModal();
  });
})();
